<template>
  <div class="columns">
    <div :class="'column-text text '+data.classNames">
      <div class="column-image">
        <div v-for="image in data.images">
          <img :src="image.url" />
          <figcaption v-if="image.caption">{{ image.caption }}</figcaption>
        </div>
      </div>
      <div v-html="data.content"></div>
    </div>
  </div>
  </div>
</template>

<script>
import { firestore } from '../main'

export default {
  name: 'TextBlock',
  props: ['data'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/TwoColBlock.vue